/**
 * /dev-error — development-only trigger for the root error page.
 *
 * There is no honest way to reach the crash boundary from the UI (that is the
 * point of it), so QA and the error-page docs need a deliberate trigger. Any
 * uncaught error in a route's beforeLoad renders RootErrorComponent, exactly
 * as a production crash would. Statically redirects home in prod builds.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/dev-error')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: '/' });
    }
    throw new Error('Dev-triggered error page (/dev-error). Nothing is actually broken.');
  },
});
